<template>
  <div class="ac1">
    <!-- 顶部横幅 -->
    <div class="page-banner">
      <div class="banner-overlay">
        <div class="banner-content">
          <h1>行业资讯</h1>
          <p>专业互联网行业动态与深度分析</p>
        </div>
      </div>
      <img src="/imgs/01.jpg" alt="行业资讯" />
    </div>

    <div class="container">
      <!-- 资讯内容区域 -->
      <div class="content-section">
        <!-- 页面标题 -->
        <div class="page-header">
          <div class="header-content">
            <h2>收费资讯</h2>
            <p class="header-subtitle">精选深度内容，助力网络行业发展</p>
            <div class="header-decoration"></div>
          </div>
        </div>

        <!-- 资讯网格 -->
        <div class="news-grid">
          <div
            class="news-card"
            v-for="(item, index) in this.myData"
            :key="index"
            @click="gopay()"
          >
            <div class="card-image">
              <img :src="item.img" :alt="item.title" />
              <div class="image-overlay">
                <div class="price-tag">
                  <span class="price-icon">💰</span>
                  <span class="price-text">1元/篇</span>
                </div>
              </div>
            </div>
            
            <div class="card-content">
              <h3 class="news-title">{{ item.title }}</h3>
              <p class="news-desc">{{ item.jj }}</p>
              
              <div class="card-meta">
                <div class="meta-left">
                  <span class="author-info">
                    <span class="author-icon">👤</span>
                    <span class="author-name">{{ item.author }}</span>
                  </span>
                  <span class="view-count">
                    <span class="view-icon">👁️</span>
                    <span class="view-text">({{ item.sub }})阅读</span>
                  </span>
                </div>
                <div class="meta-right">
                  <button class="read-btn">
                    <span class="btn-icon">📖</span>
                    <span class="btn-text">阅读全文</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

     
      </div>
    </div>

    <!-- 付款弹窗 -->
    <modal
      title="请付款阅读"
      btnType="1"
      modalType="middle"
      :showModal="showModal"
      @submit="showModal = false"
      @cancel="showModal = false"
    >
      <template v-slot:body>
        <div class="payment-content">
          <div class="payment-icon">💳</div>
          <img style="width: 275px" src="/imgs/pay.png" />
          <h2>扫码付费阅读：1元</h2>
          <p>解锁完整行业深度分析内容</p>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import Modal from "./../components/Modal.vue";
export default {
  name: "ac1",
  components: {
    Modal,
  },
  data() {
    return {
      href: "index.html",
      ac1: [],
      ac2: [],
      ac3: [],
      ac: [],
      myData: [],
      mAc: [],
      showModal: false,
      state: JSON.parse(window.localStorage.getItem("state")),
    };
  },
  mounted() {
    this.init1();
    document.title = "北京邑维智能科技有限公司";
  },
  methods: {
    init1() {
      this.axios.get("/mock/ac.json").then((res) => {
        const data = res.data;
        // 咨询区块1
        this.myData = data.slice(0, 20);
        this.ac1 = data.slice(0, 5);
        this.ac2 = data.slice(5, 10);
        this.mAc = data.slice(0, 7);
      });
    },
    // 跳转功能
    goDays(methodsWords, id) {
      this[methodsWords](id);
    },
    // 跳转详情页
    goDetails(id) {
      this.$router.push({
        path: "/sound/:" + id,
        query: { type: id },
      });
    },
    // 收费逻辑
    gopay() {
      alert("资讯每篇1元，点击确定购买");
      this.showModal = true;
    },
    msub() {
      this.$message.error("支付失败!");
      this.showModal = false;
    },
    // 登录跳转
    goLogin() {
      alert("资讯每篇1元，点击确定购买");
      this.$router.push("/login");
    },
  },
};
</script>

<style lang="scss" scoped>
// 使用方案2的颜色变量
$primary-color: #d4b896;
$primary-dark: #bfa07d;
$primary-light: #e9d4b8;
$accent-color: #5a8fb4;
$text-dark: #2c3e50;
$text-light: #7f8c8d;
$background: #f9f7f2;
$card-bg: #ffffff;

.ac1 {
  background: $background;
  min-height: 100vh;
  font-family: "Helvetica Neue", Arial, "PingFang SC", "Microsoft YaHei", sans-serif;

  // 页面横幅
  .page-banner {
    width: 100%;
    height: 400px;
    position: relative;
    overflow: hidden;
    margin-bottom: 60px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .banner-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0.3) 0%,
        rgba(0, 0, 0, 0.5) 100%
      );
      display: flex;
      align-items: center;
      justify-content: center;

      .banner-content {
        text-align: center;
        color: white;
        max-width: 800px;
        padding: 0 20px;

        h1 {
          font-size: 48px;
          font-weight: 700;
          margin-bottom: 20px;
          text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
        }

        p {
          font-size: 20px;
          opacity: 0.9;
          line-height: 1.6;
        }
      }
    }
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;

    .content-section {
      // 页面标题
      .page-header {
        margin-bottom: 50px;
        text-align: center;

        .header-content {
          h2 {
            font-size: 36px;
            font-weight: 700;
            color: $text-dark;
            margin-bottom: 15px;
            position: relative;
            display: inline-block;

            &::after {
              content: '';
              position: absolute;
              bottom: -10px;
              left: 50%;
              transform: translateX(-50%);
              width: 80px;
              height: 3px;
              background: linear-gradient(90deg, $primary-color, $accent-color);
              border-radius: 2px;
            }
          }

          .header-subtitle {
            font-size: 18px;
            color: $text-light;
            margin-bottom: 25px;
            font-style: italic;
          }

          .header-decoration {
            height: 1px;
            background: linear-gradient(90deg, transparent, $primary-color, transparent);
            margin: 0 auto;
            max-width: 300px;
          }
        }
      }

      // 资讯网格
      .news-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
        gap: 30px;
        margin-bottom: 60px;

        .news-card {
          background: $card-bg;
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 6px 25px rgba(0, 0, 0, 0.08);
          transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
          cursor: pointer;
          border: 1px solid rgba(212, 184, 150, 0.1);

          &:hover {
            transform: translateY(-8px);
            box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);

            .card-image {
              img {
                transform: scale(1.05);
              }

              .image-overlay {
                opacity: 1;
              }
            }

            .news-title {
              color: $primary-color;
            }

            .read-btn {
              background: linear-gradient(135deg, $primary-color, $primary-dark);
              color: white;
            }
          }

          .card-image {
            position: relative;
            height: 200px;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              transition: transform 0.5s ease;
            }

            .image-overlay {
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background: linear-gradient(
                to bottom,
                transparent 0%,
                rgba(0, 0, 0, 0.3) 100%
              );
              display: flex;
              align-items: flex-end;
              justify-content: flex-end;
              padding: 15px;
              opacity: 0.8;
              transition: opacity 0.3s ease;

              .price-tag {
                display: flex;
                align-items: center;
                gap: 6px;
                background: rgba(212, 184, 150, 0.9);
                color: white;
                padding: 6px 12px;
                border-radius: 20px;
                font-size: 13px;
                font-weight: 600;

                .price-icon {
                  font-size: 14px;
                }
              }
            }
          }

          .card-content {
            padding: 25px;

            .news-title {
              font-size: 18px;
              font-weight: 600;
              color: $text-dark;
              margin-bottom: 12px;
              line-height: 1.4;
              transition: color 0.3s ease;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
            }

            .news-desc {
              font-size: 14px;
              color: $text-light;
              line-height: 1.6;
              margin-bottom: 20px;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
              overflow: hidden;
            }

            .card-meta {
              display: flex;
              justify-content: space-between;
              align-items: center;

              .meta-left {
                display: flex;
                align-items: center;
                gap: 15px;

                .author-info,
                .view-count {
                  display: flex;
                  align-items: center;
                  gap: 4px;
                  font-size: 13px;
                  color: $text-light;

                  .author-icon,
                  .view-icon {
                    font-size: 12px;
                  }

                  .author-name,
                  .view-text {
                    font-size: 12px;
                  }
                }
              }

              .meta-right {
                .read-btn {
                  display: flex;
                  align-items: center;
                  gap: 6px;
                  padding: 8px 16px;
                  background: rgba(212, 184, 150, 0.1);
                  color: $primary-color;
                  border: none;
                  border-radius: 20px;
                  font-size: 13px;
                  font-weight: 600;
                  cursor: pointer;
                  transition: all 0.3s ease;

                  .btn-icon {
                    font-size: 12px;
                  }

                  &:hover {
                    transform: translateY(-1px);
                  }
                }
              }
            }
          }
        }
      }

      // 加载更多
      .load-more-section {
        text-align: center;
        margin-bottom: 60px;

        .load-more-btn {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          padding: 14px 30px;
          background: linear-gradient(135deg, $primary-color, $primary-dark);
          color: white;
          border: none;
          border-radius: 30px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(212, 184, 150, 0.3);

          &:hover {
            transform: translateY(-3px);
            box-shadow: 0 6px 20px rgba(212, 184, 150, 0.4);
            background: linear-gradient(135deg, $primary-dark, $primary-color);
          }

          .load-icon {
            font-size: 16px;
            transition: transform 0.3s ease;
          }

          &:hover .load-icon {
            transform: translateY(2px);
          }
        }
      }
    }
  }

  // 付款弹窗内容
  .payment-content {
    text-align: center;
    padding: 20px;

    .payment-icon {
      font-size: 50px;
      margin-bottom: 20px;
    }

    h2 {
      color: $text-dark;
      margin: 20px 0 10px;
    }

    p {
      color: $text-light;
      font-size: 14px;
    }
  }
}

// 响应式调整
@media (max-width: 1024px) {
  .ac1 {
    .news-grid {
      grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)) !important;
      gap: 25px !important;
    }
  }
}

@media (max-width: 768px) {
  .ac1 {
    .page-banner {
      height: 300px;
      
      .banner-content {
        h1 {
          font-size: 36px;
        }
        
        p {
          font-size: 16px;
        }
      }
    }
    
    .container {
      padding: 0 15px;
      
      .content-section {
        .page-header .header-content {
          h2 {
            font-size: 28px;
          }
          
          .header-subtitle {
            font-size: 16px;
          }
        }
        
        .news-grid {
          grid-template-columns: 1fr !important;
          gap: 20px !important;
        }
      }
    }
  }
}

@media (max-width: 480px) {
  .ac1 {
    .page-banner {
      height: 250px;
      
      .banner-content {
        h1 {
          font-size: 28px;
        }
      }
    }
    
    .container .content-section {
      .page-header .header-content h2 {
        font-size: 24px;
      }
      
      .news-grid .news-card {
        .card-content {
          padding: 20px;
        }
        
        .card-meta {
          flex-direction: column;
          align-items: flex-start;
          gap: 10px;
          
          .meta-right {
            width: 100%;
            
            .read-btn {
              width: 100%;
              justify-content: center;
            }
          }
        }
      }
    }
  }
}
</style>